var app = angular.module("leonardo");

var PropertyReportDialog = function ($scope, $state, FilterService, ReportService, FormErrorsService, $rootScope, $timeout) {

  $scope.data = {
    search: FilterService.getFilter('search'),
    levels: FilterService.getFilter('levels')
  };


  $scope.submit = function () {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }

    angular.forEach($scope.data, function (value, key) {
      if (!isEmpty(value)) {
        if (key == 'account') {
          FilterService.setFilter('account_reports', value, true);
        }
        else {
          FilterService.setFilter(key, value, true);
        }
      }
    });

    ReportService.setQuickReport({filters: $scope.data});
    $rootScope.$broadcast('no_reset_filters:updated', true);
    $timeout(function () {
      $state.go('reports.property');
    }, 100);
    $scope.closeThisDialog();
  };

};

app.controller('PropertyReportDialog', ['$scope', '$state', 'FilterService', 'ReportService', 'FormErrorsService',
  '$rootScope', '$timeout', PropertyReportDialog]);